import { AccessInternetType } from '../models/access';

import { AnyRecord } from './reduxToolkitUtils';

// to be reused in 3 sagas: editGroupSaga, editNetworkSaga and editHostSaga
const processInternetAccessEdit = (
    updatedPayload: AnyRecord,
    getGatewayIdsIfNotEmpty: () => (string | undefined)[] | undefined,
) => ({
    ...updatedPayload,
    ...(updatedPayload.internetAccess !== AccessInternetType.Global
        ? { gateways: [], gatewaysIds: [] }
        : { gatewaysIds: getGatewayIdsIfNotEmpty() }),
});

export default processInternetAccessEdit;
